var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5059_92055)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12c0 6.617 5.383 12 12 12s12-5.383 12-12a.5.5 0 00-1 0c0 6.065-4.935 11-11 11S1 18.065 1 12 5.935 1 12 1a.5.5 0 000-1C5.383 0 0 5.383 0 12zm11.89 3.85l11-11a.503.503 0 000-.7.496.496 0 00-.71 0L11.52 14.82l-4.67-4.67a.482.482 0 00-.7 0c-.2.19-.2.51 0 .7l5 5c.09.1.22.15.35.15h.03a.51.51 0 00.36-.15z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5059_92055"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
SvgSuccess.displayName = 'Success';
export default SvgSuccess;